import { createSlice } from "@reduxjs/toolkit";

const customerSlice = createSlice({
    name:"customers",
    initialState:{
        customers:null
    },
    reducers:{
        setCustomerList(state,action){
            state.customers = action?.payload;
        },
    }
})


export const {setCustomerList} = customerSlice.actions
export default customerSlice.reducer